import {Component, inject} from '@angular/core';
import {AsyncPipe} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {RouterLink} from '@angular/router';
import {PermissionsService} from '@src/app/core/services/permissions.service';
import {OnboardingGuide} from '@src/app/core/models/onboarding-guide.model';
import {OnboardingGuideService} from '@src/app/core/services/onboarding-guide.service';

@Component({
    selector: 'app-site-getting-started',
    imports: [AsyncPipe, MatButtonModule, RouterLink],
    template: `
        @let guide = guide$ | async;
        @if (canCreateSite(guide)) {
            <h2>Create your first site</h2>
            <p>Add a site to organise your survey work.</p>
            <a mat-flat-button color="primary" routerLink="/app/sites/create">Create your first site</a>
        } @else {
            <h2>No sites available yet</h2>
            <p>{{ guide?.message || 'Ask your organisation administrator to assign you to a site.' }}</p>
        }
    `,
    styles: [`
        :host { display: block; max-width: 440px; margin: 0 auto; padding: 32px 16px; text-align: center; }
        h2 { margin: 0 0 8px; }
        p { margin: 0 0 20px; }
        a { max-width: 100%; height: auto; min-height: 40px; padding: 10px 16px; white-space: normal; }
    `],
})
export class SiteGettingStartedComponent
{
    public readonly permissions = inject(PermissionsService);
    public readonly guide$ = inject(OnboardingGuideService).guide$;

    public canCreateSite(guide: OnboardingGuide | null): boolean {
        return this.permissions.can('add_sites') && (!guide || guide.tasks.some(task => task.key === 'site'));
    }
}
